/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import Utils from '../utils/utils';
import { PRIVATE_PATH } from '../constants';

const ProtectedRoute = ({ component: Component, ...rest }) => (
	<Route
		{...rest}
		render={() =>
			(rest.featureCode ? Utils.isFeatureEnabled(rest.featureCode, rest.features) : true) &&
			Utils.isAuthorizedExact(rest.pathPermission, rest.userPermissions) ? (
				<Component {...rest} />
			) : (
				<Redirect to={PRIVATE_PATH.SHIFTS} />
			)
		}
	/>
);

export default ProtectedRoute;
